import React, { useContext, useState } from 'react';
import { addcontext } from '../ContextShare/ContextShare';

function FilterTable({setIsFilterClicked}) {
    const {filterMembersTable,setfilterMembersTable}=useContext(addcontext)
    const [filter, setFilter] = useState({
        all_member: false,
        is_member: false,
        non_member: false
    });

    const handleRadioChange = (event) => {
        const { id } = event.target;
        if (id === 'default') {
            setFilter({all_member: true});
        } else if (id === 'Duration') {
            setFilter({is_member: true });
        } else if (id === 'Date') {
            setFilter({non_member: true });
        }
    };

    const handleApply = () => {
        console.log(filter);
        setfilterMembersTable(filter)
        setIsFilterClicked(false)
    };

    const handleReset = () => {
        setFilter({});
        setfilterMembersTable({})
    };

    return (
        <div className='w-full'>
            <div className='border bg-white w-full h-full flex mt-5 rounded-lg shadow-xl' style={{ fontFamily: 'ropa sans' }}>
                <div className='flex flex-col h-full w-full'>
                    {/* ---Sort By:--- */}
                    <div className='ms-5 mt-5'>
                        <h3 className='text-lg' style={{ color: '#6E6893' }}>Sort By :</h3>
                    </div>
                    {/* Default */}
                    <div className='flex flex-row ms-5 mt-4 justify-between'>
                        <label htmlFor='default'>View All</label>
                        <input type="radio" id='default' className='me-5 w-5' name='sort' onChange={handleRadioChange} checked={filter.all_member} />
                    </div>
                    {/* Duration */}
                    <div className='flex flex-row ms-5 mt-4 justify-between'>
                        <label htmlFor='Duration'>View Members</label>
                        <input type="radio" id='Duration' className='me-5 w-5' name='sort' onChange={handleRadioChange} checked={filter.is_member} />
                    </div>
                    {/* Date Modified */}
                    <div className='flex flex-row ms-5 mt-4 justify-between mb-5'>
                        <label htmlFor='Date'>View Non Members</label>
                        <input type="radio" id='Date' className='me-5 w-5' name='sort' onChange={handleRadioChange} checked={filter.non_member} />
                    </div>
            
                    <hr className='ms-3 me-3'/>
                    
                    <div className='flex justify-center mb-5 flex-row'>
                        <button
                            className='w-5/12 pl-3 pr-3 pt-1 pb-1 bg-green-600 text-white rounded-lg me-2'
                            onClick={handleApply}
                            style={{ cursor: 'pointer' }}
                        >
                            Apply
                        </button>
                        <button
                            className='w-5/12 pl-3 pr-3 bg-white text-black rounded-lg border border-red-500 hover:bg-success'
                            onClick={handleReset}
                            style={{ cursor: 'pointer' }}
                        >
                            Reset
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FilterTable;
